import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

class MyClassesStore extends ReduceStore {

    getInitialState() {
        return [];
    }

    
    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.MODULE_CLASS_LIST_REQUEST:
                return [];
                
            case ActionTypes.MODULE_CLASS_LIST_SUCCESS:
                return action.data;
                
            default:
                return state;
        }
    }

}

export default new MyClassesStore(CentricDispatcher);

